import Logo from '@/components/logo/logo';
import { NavMenu } from '@/components/nav-menu/nav-menu';
import { Flex, Layout, Drawer } from 'antd';
import { ReactNode, useState } from 'react';
import styles from './default.layout.module.scss';
import { useScreenSize } from '@/hooks/use-screen-size/use-screen-size';
import NavMobile from '@/components/nav-mobile/nav-mobile';

interface DefaultLayoutProps {
  children: ReactNode;
}

export default function DefaultLayout({ children }: DefaultLayoutProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const screenSize = useScreenSize();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isSiderVisible = screenSize.width >= 1024 || isMenuOpen;
  const { Sider, Content } = Layout;

  return (
    <Layout data-testid="default-layout" hasSider className={styles.defaultLayout}>
      <NavMobile className={styles.navMobile} toggleMenu={toggleMenu} />

      {screenSize.width < 1024 && (
        <Drawer title="Menu" placement="left" onClose={toggleMenu} open={isMenuOpen} width={300}>
          <Flex vertical className={styles.defaultLayoutSiderContainer}>
            <Logo onLogoClick={toggleMenu} />
            <NavMenu onMenuItemClick={toggleMenu} />
          </Flex>
        </Drawer>
      )}

      {screenSize.width >= 1024 && (
        <Sider
          width="fit-content"
          className={`${styles.defaultLayoutSider} ${!isSiderVisible ? styles.hidden : ''}`}
        >
          <Flex
            data-testid="sider-container"
            vertical
            className={styles.defaultLayoutSiderContainer}
          >
            <div className={styles.logoButtonWrapper}>
              <Logo onLogoClick={toggleMenu} />
            </div>
            <NavMenu onMenuItemClick={toggleMenu} />
          </Flex>
        </Sider>
      )}

      <Layout data-testid="default-layout-content" className={styles.defaultLayoutContent}>
        <Content>{children}</Content>
      </Layout>
    </Layout>
  );
}
